export const COLUMN_WIDTH = 96;
export const BASE_COLUMNS_WIDTH = 196;
export const NOT_APPLICABLE = "n/a";
